export const getDefaultValues = (notificationStyle) => ({
  NotificationStyleType: notificationStyle?.NotificationStyleType || -1,

  NotificationStyleImageUrl: notificationStyle?.NotificationStyleImageUrl || '',

  NotificationStyleLable: notificationStyle?.NotificationStyleLable || '',

  NotificationStylePaddingTop: notificationStyle?.NotificationStylePaddingTop || '',

  NotificationStylePaddingButtom: notificationStyle?.NotificationStylePaddingButtom || '',

  NotificationStylePaddingLeft: notificationStyle?.NotificationStylePaddingLeft || '',

  NotificationStylePaddingRight: notificationStyle?.NotificationStylePaddingRight || '',
});
